import { MessageCircle, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, PROJECT } from "../../data/project";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A3626] text-[#F4F2EC] pt-20 md:pt-28 pb-10"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="bg-[#F4F2EC] inline-block p-4">
              <img
                src={BRAND.agencyLogo}
                alt="PK Properties"
                className="h-12 w-auto"
              />
            </div>
            <p className="mt-7 max-w-md text-[#F4F2EC]/65 font-light leading-relaxed">
              {BRAND.agency} is the appointed broker for Hudayriyat Golf
              Estates by Modon. Our private-client team specialises in island
              and golf-fronting acquisitions across Abu Dhabi.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div
              className="overline mb-5"
              style={{ color: "rgba(244,242,236,0.55)" }}
            >
              Contact
            </div>
            <ul className="space-y-4">
              <li>
                <a
                  data-testid="footer-phone"
                  href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
                  className="flex items-start gap-3 hover:text-[#B3906A] transition-colors"
                >
                  <Phone className="w-4 h-4 mt-1" strokeWidth={1.5} />
                  <div>
                    <div className="font-serif text-lg">{BRAND.phone}</div>
                    <div className="text-xs text-[#F4F2EC]/55">
                      Carlton Hammond
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${BRAND.email}`}
                  className="flex items-center gap-3 hover:text-[#B3906A] transition-colors"
                >
                  <Mail className="w-4 h-4" strokeWidth={1.5} />
                  <span className="font-serif text-lg">{BRAND.email}</span>
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={`https://wa.me/${BRAND.phoneRaw}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 hover:text-[#B3906A] transition-colors"
                >
                  <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
                  <span className="font-serif text-lg">WhatsApp</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <div
              className="overline mb-5"
              style={{ color: "rgba(244,242,236,0.55)" }}
            >
              The Estate
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1" strokeWidth={1.5} />
              <div>
                <div className="font-serif text-lg">{PROJECT.name}</div>
                <div className="text-[#F4F2EC]/65 mt-1">
                  {PROJECT.island}, {PROJECT.city}
                </div>
                <div className="text-[#F4F2EC]/55 text-xs mt-3 tracking-[0.18em] uppercase">
                  Developer · {PROJECT.developer}
                </div>
                <div className="text-[#F4F2EC]/55 text-xs mt-1 tracking-[0.18em] uppercase">
                  Handover · {PROJECT.handover}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F4F2EC]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[11px] text-[#F4F2EC]/45 tracking-[0.18em] uppercase">
            © {year} {BRAND.agency}. All rights reserved.
          </div>
          <div className="text-[11px] text-[#F4F2EC]/45 max-w-2xl leading-relaxed">
            Information presented is indicative and subject to change. All
            renderings, prices and projections are provided for marketing
            purposes only and do not constitute an offer or contract.
          </div>
        </div>
      </div>
    </footer>
  );
}
